import React from 'react'
import PropTypes from 'prop-types'
import { Avatar, Chip, SvgIcon, Tooltip } from '@mui/material'

const ICON_SIZE = 16
const AVATAR_SIZE = 20

const ServiceDetailChip = ({ IconComponent, label, tooltip, paletteColor, paletteVariant = 'main', ...rest }) => {
  if (!label) return null

  const avatarSlot = paletteColor
    ? {
        avatar: (
          <Avatar sx={theme => ({ width: AVATAR_SIZE, height: AVATAR_SIZE, bgcolor: theme.palette[paletteColor][paletteVariant] })}>
            <SvgIcon inheritViewBox sx={{ fontSize: ICON_SIZE, color: 'common.white' }}>
              <IconComponent />
            </SvgIcon>
          </Avatar>
        ),
      }
    : {
        avatar: (
          <Avatar
            sx={theme => ({
              width: AVATAR_SIZE,
              height: AVATAR_SIZE,
              bgcolor: 'transparent',
              border: `1.5px solid ${theme.palette.text.secondary}`,
            })}
          >
            <SvgIcon inheritViewBox sx={{ fontSize: ICON_SIZE, color: 'text.secondary' }}>
              <IconComponent />
            </SvgIcon>
          </Avatar>
        ),
      }

  return (
    <Tooltip title={tooltip} arrow disableInteractive>
      <Chip
        size="small"
        {...avatarSlot}
        label={label}
        variant="outlined"
        sx={theme => ({
          '& .MuiChip-avatar': { width: AVATAR_SIZE, height: AVATAR_SIZE },
          ...(paletteColor && {
            borderColor: theme.palette[paletteColor][paletteVariant],
            color: theme.palette[paletteColor][paletteVariant],
          }),
        })}
        {...rest}
      />
    </Tooltip>
  )
}

ServiceDetailChip.propTypes = {
  IconComponent: PropTypes.elementType.isRequired,
  label: PropTypes.string,
  tooltip: PropTypes.string.isRequired,
  paletteColor: PropTypes.string,
  paletteVariant: PropTypes.string,
}

export default ServiceDetailChip
